<template>
  <div class="display-product-list-type">
    <ul>
      <li :class="vg_storeItemDisplayType == 'list' ? 'active' : ''" @click.prevent="va_setItemDisplayType('list')">
        <svg width="18" height="10" viewBox="0 0 18 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 6H2V4H0V6ZM0 10H2V8H0V10ZM0 2H2V0H0V2ZM4 6H18V4H4V6ZM4 10H18V8H4V10ZM4 0V2H18V0H4ZM0 6H2V4H0V6ZM0 10H2V8H0V10ZM0 2H2V0H0V2ZM4 6H18V4H4V6ZM4 10H18V8H4V10ZM4 0V2H18V0H4Z" fill="black"/>
        </svg>
      </li>
      <li :class="vg_storeItemDisplayType == 'grid' ? 'active' : ''" @click.prevent="va_setItemDisplayType('grid')">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 0V8H8V0H0ZM6 6H2V2H6V6ZM0 10V18H8V10H0ZM6 16H2V12H6V16ZM10 0V8H18V0H10ZM16 6H12V2H16V6ZM10 10V18H18V10H10ZM16 16H12V12H16V16Z" fill="black" fill-opacity="0.87"/>
        </svg>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
export default {
  computed: {
    ...mapGetters({
      vg_storeItemDisplayType: "storeprofile/itemDisplayType",
    }),
  },
  methods: {
    ...mapActions({
      va_setItemDisplayType: "storeprofile/setItemDisplayType",
    })
  },
}
</script>